import { render, staticRenderFns } from "./printPallet.vue?vue&type=template&id=c249da26&"
import script from "./printPallet.vue?vue&type=script&lang=js&"
export * from "./printPallet.vue?vue&type=script&lang=js&"
import style0 from "./printPallet.vue?vue&type=style&index=0&id=c249da26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports